export const MAX_CARDS = 5;
export const DEMO_CARD_SPOTLIGHT_KEY = 'deep-dive-card-demo-card-spotlight';
// If you are changing the value of DEMO_PROJECT_CARD_SPOTLIGHT_TARGET_KEY here, change it in `src/packages/servicedesk/itsm-first-session-flow/src/common/constants.tsx` also
export const DEMO_PROJECT_CARD_SPOTLIGHT_TARGET_KEY = 'demo-project-card';
export const ITSM_SAMPLE_PROJECT_CARD_SPOTLIGHT_TARGET_KEY = 'itsm-sample-project-card';
export const FIRST_USER_CREATED_JSM_PROJECT_CARD_SPOTLIGHT_TARGET_KEY =
	'first-user-created-jsm-project-card';
// End of comments
